// app/javascript/controllers/message_form_controller.js
import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "fileInput", "submitBtn"]

  connect() {
    // this.inputTarget.focus()
  }

  handleKeydown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.submit()
    }
  }

  submit(event) {
    if (event) event.preventDefault()

    const content = this.inputTarget.value.trim()
    const files = this.fileInputTarget.files

    if (!content && files.length === 0) return

    this.submitBtnTarget.disabled = true
    this.element.requestSubmit()
  }
}
